import React from 'react';
import { Button, Tooltip, withStyles } from '@material-ui/core';
import { minTwoDigits } from '../../config/utils';

type Color = 'inherit' | 'primary' | 'secondary' | 'default';

interface OKRButtonProps {
	className?: string;
	title?: React.ReactNode | String;
	text?: React.ReactNode | String;
	handleClick?: (event: any) => void;
	disabled?: boolean;
	icon?: React.ReactNode;
	color?: Color;
	percentage?: any;
	style?: any;
	handleOver?: (event: any) => void;
	handleLeave?: (event: any) => void;
	tooltipClassName?: string;
	buttonType?: any;
	id?: string;
	tooltipPlacement?: any;
	disableRipple?: boolean;
	wrapClassName?: string;
}

export const OKRButton: React.FC<OKRButtonProps> = (props) => {
	const {
		className,
		percentage,
		text,
		handleClick,
		disabled,
		icon,
		title,
		style,
		handleOver,
		handleLeave,
		tooltipClassName,
		buttonType,
		id,
		tooltipPlacement,
		disableRipple,
		wrapClassName,
	} = props;

	return (
		<Tooltip title={title || ''} arrow classes={{ popper: tooltipClassName || '' }} placement={tooltipPlacement}>
			{buttonType === 'createOkr' || buttonType === 'disableButtonTooltip' ? (
				<span className={wrapClassName || ''}>
					<Button
						className={className || ''}
						onClick={handleClick}
						disabled={disabled || false}
						style={style || {}}
						onMouseOver={handleOver}
						onMouseLeave={handleLeave}
						id={id ? id : ''}
						disableRipple={disableRipple}
					>
						<span className='icon'>{icon}</span> {text || ''}
						{percentage && !isNaN(percentage?.teamScore) && (
							<span style={{ background: `#${percentage.progressCode}` }} className='percentage'>
								{minTwoDigits(percentage.teamScore)}%
							</span>
						)}
					</Button>
				</span>
			) : (
				<Button
					className={className || ''}
					onClick={handleClick}
					disabled={disabled || false}
					style={style || {}}
					onMouseOver={handleOver}
					onMouseLeave={handleLeave}
					id={id ? id : ''}
					disableRipple={disableRipple}
				>
					<span className='icon'>{icon}</span> {text || ''}
					{percentage && !isNaN(percentage?.teamScore) && (
						<span style={{ background: `#${percentage.progressCode}` }} className='percentage'>
							{minTwoDigits(percentage.teamScore)}%
						</span>
					)}
				</Button>
			)}
		</Tooltip>
	);
};
